import React, {Fragment, useState} from "react";
import {NavigationProps, WizardNavigation} from "../../../_shared/wizard/WizardNavigation";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {SearchedMember} from "../../../../models/membership.models";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {Members} from "../../Members";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    selectedCount: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    }
}));

interface Props extends NavigationProps {
    organizationId: number,
    onChangeSelectedMembers: (selectedMembers: Map<string, SearchedMember>) => void
}

export const Step1Selection: React.FC<Props> = ({onChangeSelectedMembers, organizationId, ...props}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [selectedMembers, setSelectedMembers] = useState<Map<string, SearchedMember>>(new Map());

    const buildMapId: (member: SearchedMember) => string = (member) => `${member.userId}-${member.organizationUnitName}`;
    const actions = (o: any) => <Checkbox
        checked={selectedMembers && selectedMembers.has(buildMapId(o))}
        onChange={e => onMemberSelected(o, e)}
        color="primary"
        inputProps={{'aria-label': 'primary checkbox'}}
    />;

    const updateMembersSelected = (oldSet: Map<string, SearchedMember>, member: SearchedMember, checked: boolean): Map<string, SearchedMember> => {
        const newSet = new Map(oldSet);
        if (checked) newSet.set(buildMapId(member), member);
        else if (!checked && newSet.has(buildMapId(member))) newSet.delete(buildMapId(member));
        return newSet;
    }

    const onMemberSelected = (o: SearchedMember, e: any) => {
        const checked = e.target.checked;
        setSelectedMembers(oldSet => updateMembersSelected(oldSet, o, checked));
    }


    const onSubmitChange = (changeTab: () => void) => {
        onChangeSelectedMembers(selectedMembers);
        changeTab();
    }

    return <Fragment>
        <Grid item xs={12} className={classes.selectedCount}>
            <Typography variant="subtitle1">
                {t('Members.MoveMembers.Tabs.SelectMembers.Selected', {count: selectedMembers.size})}
            </Typography>
        </Grid>
        <Members organizationId={organizationId} actions={actions}/>
        <WizardNavigation {...props} onSubmitChange={onSubmitChange}/>
    </Fragment>
}
